/** @jsx jsx */
import { jsx } from '@emotion/core'
import React, { Fragment } from 'react'
import { observer } from 'mobx-react'
import { isMobile } from 'react-device-detect'
import { Button } from '@styles/button.style'
import { HeaderIcoStyle } from '@views/PrimaryLayout/Header/index.style'
import { Badge } from 'antd-mobile'
import { BadgeStyle } from '@styles/base.style'
import useRootStore from '@store/useRootStore'
import { MessageIco } from '@shared/Icon/MenuIcon'
import CashBtnImg from '@assets/images/btn/cash-btn.png'
import LuckyBagImg from '@assets/images/btn/lucky-bag.png'
import Login from '@views/Login'
import { getAllHashParameters, loadOrReload, makeActivityGageConfig } from '@utils/utils'
import { ACCOUNT_TYPE } from '@interface/common'
import { ProfileIco } from '@shared/Icon/HeaderIcon'
import classNames from 'classnames'
import { GlobalStoreKey } from '@v2/constants/common'
import AdvImg from '@components/AdvImg'
import EventFloatingButton from '@views/Matchup/EventFloatingButton'
import BetSlipMessageBtn from '@views/Popup/Message/BetSlipMessageBtn'
import BeginnersGuideButton from '@views/Guide/BeginnersGuide/Button'
import PopupUtils from '@utils/popup-utils'

const Message = (
  <span className="icon message">
    <MessageIco/>
  </span>
)

const RightContent: React.FC = () => {
  const {
    globalStore,
    userStore,
    authStore,
    joinStore,
    componentStore,
    matchupStore,
    logStore,
  } = useRootStore()
  const { notificationData } = userStore
  const { isJoinUrl } = joinStore
  const { userInfo } = authStore

  // IMG
  const headerImageUrl = globalStore.findGlobalSetting(GlobalStoreKey.INGAME_IMAGES_URL).value
  const HeaderBg = `${headerImageUrl}bg/achieve_score_profile.png`


  const onClickMessageBodyButton = () => {
    logStore.writeButtonLog({ pageId: 'f010', buttonId: '001' }).catch(console.error)
    componentStore.setExtraClubId(null)
    globalStore.setVisibleSideBar(false)
    PopupUtils.showMessagePopup()
  }

  const onClickLoginHandler = () => {
    if (isJoinUrl) {
      return
    }

    if (isMobile) {
      globalStore.setVisibleSideBar(true)
    } else {
      authStore.showLoginPopup(<Login/>)
    }
  }

  const onClickRegisterBtnHandler = () => {
    if (isJoinUrl) {
      return
    }

    joinStore.setAccountType(ACCOUNT_TYPE.LOCAL)
    loadOrReload(`/agree${getAllHashParameters(true)}`)
  }

  const makeBadgeText = () => {
    return notificationData ? notificationData.unreadMessageCount : 0
  }

  const closeMatchFilter = () => {
    matchupStore.resetTournamentFilterList()
    globalStore.setVisibleMatchFilterPopup(false)
  }

  const closeMatchupDetail = () => {
    globalStore.setVisibleMatchupDetailPopup(false)
  }

  const onClickMyInfoHandler = () => {
    logStore.writeButtonLog({ pageId: 'e010', buttonId: '001' }).catch(console.error)
    if (isMobile) {
      closeMatchFilter()
      closeMatchupDetail()
      loadOrReload('/my-info')
    } else {
      PopupUtils.showMyPagePopup(() => {
        logStore.writeButtonLog({ pageId: 'e010', buttonId: '002' }).catch(console.error)
      })
      globalStore.setVisibleSideBar(false)
    }
  }

  let rightElem: React.ReactElement
  // let profileBtnClassName = 'header-btn profile-btn'
  // let badgeBtnClassName = 'header-btn'
  // if (sideBarCollapsed) {
  //   profileBtnClassName += ' side-menu-collapsed'
  //   badgeBtnClassName += ' side-menu-collapsed'
  // } else {
  //   profileBtnClassName += ' side-menu-expand'
  //   badgeBtnClassName += ' side-menu-expand'
  // }

  // 충전 바로가기
  const onClickChargeLinkAnchor = () => {
    let url: string
    if (authStore.userInfo && authStore.authInfo) {
      logStore.writeButtonLog({ pageId: 'i010', buttonId: '007' }).catch(console.error)
      const authKey = authStore.authInfo.authKey
      url = `${process.env.HOMEPAGE_PC}/#/auth_login/${authKey}/payment`
    } else {
      url = `${process.env.HOMEPAGE_PC}/#/payment`
    }
    globalStore.toMoveWebHomePage(url)
  }

  const radius = 15
  const { dashOffset, circumference } = makeActivityGageConfig(radius)

  const progressBarName = classNames('progress-bar', {
    'adv-hidden': globalStore.userActivityInfo?.activityRewardAvailable,
  })

  let profileImg: React.ReactElement = null
  if (authStore.signedin === true) {
    if (userInfo) {
      profileImg = (
        <span className={userInfo.customProfileImg ? 'profile-img custom' : 'profile-img'}>
          {userInfo.customProfileImg ?
            (<AdvImg src={userInfo?.avatar} srcMode={'small'} alt="사진첩 이미지" className="custom-img"/>)
            :
            (<AdvImg src={userInfo?.avatar} srcMode={'small'} alt="스킨" className="zoom-img"/>)
          }
        </span>
      )
    }

    rightElem = (
      <Fragment>
        {isMobile ?
          <Fragment>
            <Button className="header-btn profile-btn" onClick={onClickMyInfoHandler}>
              {profileImg}
              <div className="progress-bar-wrap">
                <svg width="54" height="54" xmlns="http://www.w3.org/2000/svg" className={progressBarName}>
                  <defs>
                    {/*<linearGradient id="gradient" x1="0%" y1="0%" x2="120%" y2="70%">*/}
                    {/*  <stop offset="0%" style={{ stopColor: '#ea4d07' }}/>*/}
                    {/*  <stop offset="100%" style={{ stopColor: '#fbb000' }}/>*/}
                    {/*</linearGradient>*/}
                    <filter id="drop-shadow" x="0" y="0" width="54" height="54" filterUnits="userSpaceOnUse"
                            colorInterpolationFilters="sRGB">
                      <feFlood floodOpacity="0" result="BackgroundImageFix"/>
                      <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                                     result="hardAlpha"/>
                      <feMorphology radius="1" operator="dilate" in="SourceAlpha" result="effect1_dropShadow_147_573"/>
                      <feOffset/>
                      <feGaussianBlur stdDeviation="4"/>
                      <feComposite in2="hardAlpha" operator="out"/>
                      <feColorMatrix type="matrix" values="0 0 0 0 0.960784 0 0 0 0 0.407843 0 0 0 0 0 0 0 0 1 0"/>
                      <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_147_573"/>
                      <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_147_573" result="shape"/>
                    </filter>
                  </defs>
                  <circle cx="27" cy="27" r={radius} fill="none" className="bg"/>
                  <circle cx="27" cy="27" r={radius} fill="none" strokeDasharray={circumference}
                          strokeDashoffset={dashOffset}
                          className="processing"/>
                </svg>
              </div>
              {globalStore.userActivityInfo?.activityRewardAvailable &&
                <img src={HeaderBg} alt="보상획득 가능시 프로필 배경" className="available-profile-bg" loading="lazy"/>
              }
            </Button>
            <BetSlipMessageBtn/>
            {/* ******************* 페이백 이벤트 버튼(MO) ******************* */}
            <EventFloatingButton className="header"/>
          </Fragment>
          :
          <Button className="header-btn profile-btn pc" onClick={onClickMyInfoHandler}>
            <ProfileIco/>
          </Button>
        }

        {!isMobile && <Button
          key="RightContent:MessageButton"
          css={HeaderIcoStyle}
          onClick={onClickMessageBodyButton}
          className="header-btn"
        >
          {Message}
          <Badge text={makeBadgeText()} overflowCount={99} css={BadgeStyle} className="badge-style"/>
        </Button>}

        {!isMobile &&
          <Button onClick={onClickChargeLinkAnchor} className="header-btn charge-btn">
            <img src={CashBtnImg} alt="충전 버튼" className="bg-img" style={{ width: '90px' }}/>
            <img src={LuckyBagImg} alt="복주머니" className="bag-img"/>
          </Button>
        }

        {/* ******************* 초보자 가이드 영상 버튼(PC) ******************* */}
        {!isMobile && <BeginnersGuideButton/>}

      </Fragment>
    )
  } else if (authStore.signedin === false) {
    rightElem = (
      <Fragment>
        {isMobile ? (
          <Fragment>
            <Button
              primary
              key="RightContent:LoginButton"
              css={HeaderIcoStyle}
              className={`header-btn login-btn ${isJoinUrl ? 'adv-hidden-fill-space' : ''}`}
              onClick={onClickLoginHandler}
            >
              로그인
            </Button>
          </Fragment>
        ) : (
          <Fragment>
            <Button
              primary
              key="RightContent:LoginButton"
              css={HeaderIcoStyle}
              className={`header-btn login-btn ${isJoinUrl ? 'adv-hidden-fill-space' : ''}`}
              onClick={onClickLoginHandler}
            >
              로그인
            </Button>
            <Button
              primary
              key="RightContent:Register"
              css={HeaderIcoStyle}
              className={`header-btn sign-up ${isJoinUrl ? 'adv-hidden-fill-space' : ''}`}
              onClick={onClickRegisterBtnHandler}
            >
              회원가입
            </Button>
          </Fragment>
        )
        }
      </Fragment>
    )
  }

  return rightElem
}

export default observer(RightContent)
